$(document).ready(function(){
  $(".ref_link").click(function() {
               $("html").removeClass('show-nav');
               $(".site-nav--dropdown.seggested-pages").hide();
             });
  
 	/* $('body#suggested-uses ul#accessibleNav > li:nth-child(4) > a').append(' <span class="icon-fallback-text sugg"><span class="icon icon-arrow-down" aria-hidden="true"></span></span>'); */
    
  
  $('#ref_menu a').hover(function(e){
    if($('.stayDisplayed').length == 0){
      var id = $(this).attr('rel');
      $('#link1').hide();
      $('#'+id).show();
      
    }
  },function(e){
    if($('.stayDisplayed').length == 0){
      var id = $(this).attr('rel');
      $('#'+id).hide();
    }
  });

  $('#ref_menu a').click(function(e){
    var id = $(this).attr('rel');

    $('.ref_text').removeClass('stayDisplayed');
    $('.ref_text').hide();
    $('#'+id).addClass('stayDisplayed');
    $('#'+id).show();
  });
  
  
  // Tooltip only Text
  $('a.product-photo-thumb img').hover(function(){
          // Hover over code
          var alt = $(this).attr('alt');
          $(this).data('tipText', alt).removeAttr('alt');
          $('<p class="photo-thumb-tooltip"></p>')
          .text(alt)
          .appendTo('body')
          .fadeIn('slow');
  }, function() {
          // Hover out code
          $(this).attr('alt', $(this).data('tipText'));
          $('.photo-thumb-tooltip').remove();
  }).mousemove(function(e) {
          var mousex = e.pageX + 20; //Get X coordinates
          var mousey = e.pageY + 10; //Get Y coordinates
          $('.photo-thumb-tooltip')
          .css({ top: mousey, left: mousex })
  });
  
  // Thumbnail click change variation
  thumbnails = $('img[src*="/products/"]').not(':first');
  if (thumbnails.length) {
    thumbnails.bind('click', function() {
      var arrImage = $(this).attr('src').split('?')[0].split('.');
      var strExtention = arrImage.pop();
      var strRemaining = arrImage.pop().replace(/_[a-zA-Z0-9@]+$/,'');
      var strNewImage = arrImage.join('.')+"."+strRemaining+"."+strExtention;
      if (typeof variantImages[strNewImage] !== 'undefined') {
          productOptions.forEach(function (value, i) {
           optionValue = variantImages[strNewImage]['option-'+i];
           if (optionValue !== null && $('.single-option-selector:eq('+i+') option').filter(function() { return $(this).text() === optionValue }).length) {
             $('.single-option-selector:eq('+i+')').val(optionValue).trigger('change');
           }
        });
      }
    });
  }


  
});

    $("#mobile-selectSuggest").change(function() {
    var id = $(this).val();
    $("#link" + id).addClass("toggleShow").siblings(".toggleShow").removeClass("toggleShow");
  }).change(); 

// Arrow Key trigger for slider
$("body").keydown(function(e){
    // left arrow
    if ((e.keyCode || e.which) == 37)
    {   
        $("a.flex-prev").click();
    }
    // right arrow
    if ((e.keyCode || e.which) == 39)
    {
        $("a.flex-next").click();
    }   
});


/*(function($){
	function suggestedUses() {

      
		var windowWidth = $(window).width();
        if(windowWidth <= 768){
         
          $('ul#accessibleNav > li:nth-child(4)').append($('ul.seggested-pages'));
          
          $('ul#accessibleNav > li:nth-child(4)').children('ul').hide();
          
          $('ul#accessibleNav > li:nth-child(4)').click(function () {

            if ($(this).children('ul,p').is(':hidden') == true) {
              $(this).children('ul,p').show(); 
              return false
            }
          })
             
           
        }
      	if(windowWidth >= 769){
           
          $('#ref_menu').append($('ul.seggested-pages'));
          $('ul.seggested-pages').show();
          
        }
      
      
      
	}
	$(document).ready(function(){
		suggestedUses();

		$(window).resize(function() {
			setTimeout(function() {
	      		suggestedUses();
			}, 120);
		});
	});
})(jQuery); */

  
